export const feeTypes = {
    OutboundPayment: "outbound_payment",
	Contract:        "contract",
	InvoiceACH:      "invoice_ach",
	InvoiceCard:     "invoice_card",
	Monthly:         "monthly_fee",
  }